import { LitElement, html, css, TemplateResult } from 'lit';
import {property, customElement} from 'lit/decorators.js';

@customElement('voyage-dialog-popup-body-warning')
export class VoyageDialogPopupBodyWarning extends LitElement
{
    @property({ attribute: false }) icon: TemplateResult | HTMLElement = html``;
    @property({ attribute: false  }) warningSummary: string = "";
    @property({ attribute: false  }) warningDescription: string = "";
    @property({ attribute: false  }) descriptionBackgroundVisible: boolean = false;
    @property({ attribute: false  }) descriptionTextAlign: string = "";

    static get styles() {
        return [
            css`
                .container {
                    margin: 0 auto;
                    display: flex;
                    flex-direction: column;
                    justify-content: center;
                    align-items: center;
                    width: 713px;
                    padding: 20px 40px 20px 40px;
                    background: var(--neutrals-grey-10);
                    font-family: 'MaerskText';
                    font-size: 14px;
                }

                .warning-icon {
                    place-content: center;
                    fill: var(--voyage-error-red);
                    display: grid;
                    margin-bottom: 20px;
                }

                .warning-icon > svg {
                    width: 41px; 
                    height: 37px;
                }

                .warning-summary {
                    color: var(--neutrals-grey-02);
                    margin-bottom: 10px;
                }

                .description {
                    place-content: center;
                    padding: 20px;
                    border-radius: 4px;
                }

                .description-background {
                    background: var(--voy-alert-message-background-color);
                    border: 1px solid var(--voyage-error-red);
                }

                .description-center {
                    text-align: center;
                }
            `
        ];
    }

    render()
    {
        return html`
            <div class="container">
                <div class="warning-icon">${this.icon}</div>
                <div class="warning-summary">${this.warningSummary}</div>
                <div class="description ${this.descriptionBackgroundVisible ? "description-background" : ""}
                    ${this.descriptionTextAlign === "center" ? "description-center" : ""}
                ">${this.warningDescription}</div>
            </div>
        `;
    }
}
